export default {
    baseUrl: "https://api.tensile.co",
}